import IntroButton from "../IntroButton";
import "./IntroductionBox.css";

const IntroCard = () => {
  return (
    <div className="intro">
      Syreeta Cummings. Software developer, Birmingham UK
      <div>
        <IntroButton />
      </div>
    </div>
  );
};

export default IntroCard;
